import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=21e2a7a5&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=21e2a7a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2a7a5",
  null
  
)

export default component.exports